export const postcodeRequired = 'Please enter a postcode';
export const invalidPostcode = 'Please enter a valid postcode';
export const postcodeSearchRequired = 'Please search for your postcode';
export const addressSelectionRequired = 'Please choose an address';
export const addressHouseNumber = 'Please enter a house number or name';
export const addressLine1Required = 'Please enter an address';
export const addressLine4Required = 'Please enter a town';
export const postcodeDoesNotExist =
  'No addresses found for this postcode. Please enter your address manually below';
export const postcodeApiFail =
  'Postcode search is currently unavailable. Please enter your address manually below';
